import { Event } from 'three';
import { $ } from '@/Engine/state';
import { eventsNumLimit } from '@/Constants/common';
import { computePointerPosition } from '@/lib/computePointerPosition';
import { onPointerMoveRoomDimensions } from '@/Engine/eventHandlers/roomDimensionChanging';
import { getIntersection, getSizingBoxesIntersection } from '@/Engine/intersections';
import { onObjectMoveMode } from '@/Engine/eventHandlers/onObjectMoveMode';
import { addBoxHelpers, removeBoxHelpers } from '@/Engine/addBoxHelper';
import { useStoreData } from '@/Store/storeData';
import { useUIOnlyStore } from '@/Store/storeUI';
import { onWallIntersection } from '@/Engine/eventHandlers/onWallIntersection';
import { onNoWallIntersection } from '@/Engine/eventHandlers/onNoWallIntersection';
import { onFloorIntersection } from '@/Engine/eventHandlers/onFloorIntersection';
import { onDragAccessories } from '@/Engine/eventHandlers/onDragAccessories';
import { bracketAccessories, wallAccessories } from '@/Constants/accessories';

export const onPointerMove = (e: Event) => {
    if ($.eventsNum > eventsNumLimit) return;
    $.eventsNum += 1;
    $.createNewModule = null;
    $.pointer.copy(computePointerPosition($.container, e));
    if (useUIOnlyStore().mode === 1) {
        onPointerMoveRoomDimensions(getSizingBoxesIntersection(), getIntersection([ $.room.ceilRaycastPlane ]));
    }
    // Режим таскания и есть выделение
    if ($.dragging && $.selection) {
        if (!$.wallPointer)
            $.ctrlKey = e.ctrlKey || e.metaKey;
        onObjectMoveMode();
    } else {
        $.wallPointer = null;
        $.floorPointer = null;
        $.shelfPlace = null;
    }


    removeBoxHelpers();
    addBoxHelpers([ ...$.wardrobe.rackModules, ...$.windows, ...$.doors ]);

    if ($.tempShelf) {
        $.render();
        return;
    }
    // data будет если есть перемещаемый из меню объект
    let data = JSON.parse(JSON.stringify(useStoreData().getElementDnd));

    //TODO логика с createNewModule вероятно удалена
    if ($.createNewModule)
        data = { data: useStoreData().getItemsByIdArr([ $.createNewModule ])[0] };



    if (data?.data) {
        if (
            data.category?.name?.includes('Аксессуары') &&
            !bracketAccessories.some(accessory => data.data.name.includes(accessory)) &&
            !wallAccessories.some(accessory => data.data.name.includes(accessory))
        ) {
            console.warn('Неподдерживаемый аксессуар');
            return;
        }

        if (data.data.name.includes('боковая')) {
            onDragAccessories(data);
            return;
        }

        // selectionBox.unselect();
        const floorIntersection = getIntersection([ $.room.floorRaycastPlane ]);
        if (floorIntersection[0] && data) {
            onFloorIntersection(floorIntersection[0], data);
            // $.render();
            // return;
        }

        const wallIntersections = getIntersection($.room.raycastPlanes);
        if (wallIntersections[0] && data) {
            onWallIntersection(wallIntersections[0], data);
        } else {
            onNoWallIntersection();
        }
    }

    $.render();
};
